import { createContext, ReactElement } from 'react'
import { ButtonStyle } from 'components/ui/Button/helpers'

export type PromptOption = string | { label: string; value: string }

export type PromptDialogArgs = {
  title?: string
  fieldLabel?: string
  placeholder?: string
  message?: string | ReactElement
  okButton?: string
  cancelButton?: string
  color?: ButtonStyle['color']
  options?: PromptOption[]
}

export type PromptDialogContextType = {
  prompt: (args: PromptDialogArgs) => Promise<string>
  close: () => void
}

export const PromptDialogContext = createContext<PromptDialogContextType>({
  prompt: async () => '',
  close: () => {
    // do nothing
  }
})
